import { useEffect, useState } from "react";

export const useShowReward = (key, defaultValue) => {
  const [state, setState] = useState(() => {
    const saved = localStorage.getItem(key);
    return saved ? JSON.parse(saved) : defaultValue;
  });

  useEffect(() => {
    localStorage.setItem(key, JSON.stringify(state));
  }, [key, state]);

  const clearState = () => {
    localStorage.removeItem(key);
    setState(defaultValue);
  };

  return [state, setState, clearState];
};
